import {
  Button,
  capitalize,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useCallback, useEffect, useState } from "react";

import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNotify } from "../../../providers/NotificationProvider";
import { applicantSelector } from "../../../store/applicantsSlice";
import FormAutoComplete from "./../../../Controllers/AutoComplete";
import FormTextField from "./../../../Controllers/Input";
import service from "./../helpers/GifService";
import { setColleagues } from "../../../store/proposalSlice";
import { ApplicantType } from "../../advisors/Constants";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  autocomplete: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const defaultState = {
  institutions: [],
  titles: [],
  researchAreas: [],
  researchSubAreas: [],
  form: {},
};

const roles = [
  { label: "PI", id: "1" },
  { label: "CI", id: "0" },
];

export default function AddApplicantDialog(props) {
  const { open, handleClose } = props;
  const classes = useStyles();
  const methods = useForm();
  const notify = useNotify();
  const dispatch = useDispatch();
  const [state, setState] = useState({ ...defaultState });
  const [loading, setLoading] = useState(false);

  const { handleSubmit } = methods;
  const applicant = useSelector(applicantSelector);
  const getInstitutions = useCallback(async () => {
    const institutions = (await service.getAllInstitutions()).map((i) => ({
      id: i.institutionId,
      label: i.name,
    }));
    setState((state) => ({ ...state, institutions }));
  }, []);

  const getTitles = useCallback(async () => {
    const titles = (await service.GetContactTitles()).map((t) => ({
      id: t.value,
      label: t.label,
    }));

    setState((state) => ({ ...state, titles }));
  }, []);
  useEffect(() => {
    getInstitutions();
    getTitles();
  }, [getInstitutions, getTitles]);

  const onSubmit = async (data) => {
    const capData = {
      ...data,
      firstname: capitalize(data.firstname),
      lastname: capitalize(data.lastname),
    };
    setLoading(true);
    try {
      const proposalId = applicant.proposalId;
      await service.addApplicant(proposalId, capData);
      const propsosalApplicants = await service.getColleagues({
        proposalId,
      });
      const retrivedApplicants = propsosalApplicants
        .filter((ad) => ad.pici === ApplicantType.PI)
        .map((ad) => ({
          email: ad.email,
          name: ad.name,
          id: ad.id,
        }));
      dispatch(setColleagues(retrivedApplicants));
      // setState((state) => ({ ...state, password }));
      notify.show("Applicant added successfully!");
      handleClose();
    } catch (ex) {
      notify.show("Error while adding applicant", { severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  const ValidateEmail = (mail) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }
    return "You have entered an invalid email address";
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Add Applicant</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please fill in initial data for the new applicant
        </DialogContentText>
        <FormProvider {...methods}>
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormAutoComplete
              name="titleCode"
              label="Title"
              options={state.titles}
              required
            />
            <FormTextField
              name="firstname"
              label="First Name"
              required
              inputProps={{ style: { textTransform: "capitalize" } }}
            />
            <FormTextField
              name="lastname"
              label="Last Name"
              required
              inputProps={{ style: { textTransform: "capitalize" } }}
            />
            <FormTextField
              name="email"
              label="Email"
              validate={ValidateEmail}
              required
            />
            <FormAutoComplete
              name="institutionId"
              label="Institution"
              options={state.institutions}
              required
            />
            <FormAutoComplete
              name="applicantType"
              label="Role"
              options={roles}
              required
            />
            <FormTextField name="cellphone" label="Cellphone" required />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
        >
          {loading ? "Inviting..." : "Invite"}
        </Button>
        <Button onClick={handleClose} color="primary" disabled={loading}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
